export const _en = {
    syncButton: {
        label: "Trigger synchronization"
    }
};


export const _fr = {
    syncButton: {
        label: "Démarrer la synchronisation"
    }
};